import { render } from "./KpiTag.vue?vue&type=template&id=59028e4c&scoped=true&ts=true"
import script from "./KpiTag.vue?vue&type=script&lang=ts"
export * from "./KpiTag.vue?vue&type=script&lang=ts"

import "./KpiTag.vue?vue&type=style&index=0&id=59028e4c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59028e4c"]])

export default __exports__